let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = Promise.all([load("k9kY4"), load("hdBGO"), load("6zfzy"), load("aZinD"), load("6StWh"), load("ew1CD")]).then(() => parcelRequire('gEJ5F'));